var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchOffThemed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 26,
    viewBox: "0 0 44 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9FA7D1",
    d: "M31.167 0H12.833C5.758 0 0 5.832 0 13s5.758 13 12.833 13h18.334C38.242 26 44 20.168 44 13S38.242 0 31.167 0z",
    transform: "translate(-657 -9492) matrix(-1 0 0 1 701 9492) matrix(-1 0 0 1 44 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.333 20.857c-4.044 0-7.333-3.332-7.333-7.429C24 9.332 27.29 6 31.333 6c4.045 0 7.334 3.332 7.334 7.428 0 4.097-3.29 7.43-7.334 7.43z",
    transform: "translate(-657 -9492) matrix(-1 0 0 1 701 9492)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOffThemed);
export default __webpack_public_path__ + "static/media/switch-off-themed.4d44ca8426e3e8f0dc3e3b280b7f7913.svg";
export { ForwardRef as ReactComponent };